import { gql } from '@apollo/client';

export const ADD_DURATION_DATE = gql`
  mutation AddDurationDate($input: AddSprintInput) {
    addSprint(input: $input) {
      duration
      id
      project_id
      start_date
    }
  }
`;

export const GET_SPRINT_DETAIL = gql`
query Sprint($input: getSprint) {
  sprint(input: $input) {
    duration
    id
    project_id
    start_date
  }
}
`;
